export const getAttribute = (el, name, prefix="gtm") => {
    return el.getAttribute(`data-${prefix}-${name}`) || el.querySelector(`[data-${prefix}-${name}]`)?.getAttribute(`data-${prefix}-${name}`) || null
}
